"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTag = exports.hash = void 0;
const sha256_1 = __importDefault(require("crypto-js/sha256"));
const hash = (message) => {
    const hashedMessage = sha256_1.default(message);
    return hashedMessage.toString();
};
exports.hash = hash;
const calculateTag = (address, message) => {
    const hashedMessage = hash(message);
    const tag = `@${address.substring(0, 6)}-${hashedMessage}`;
    return tag;
};
exports.calculateTag = calculateTag;
//# sourceMappingURL=util.js.map